/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

import quickFetch from 'quick-fetch';
export const getEarlyRequest = ({
  key,
  defaultRequestFn,
  forceUseDefault = false
}) => {
  if (!key && !defaultRequestFn) {
    throw new Error('Key and request fallback are required.');
  }
  const earlyRequest = quickFetch.getRequestStateByName(key);
  if (earlyRequest && !forceUseDefault) {
    return new Promise((resolve, reject) => {
      earlyRequest.whenFinished(result => {
        resolve(result);
        quickFetch.removeEarlyRequest(key);
      });
      earlyRequest.onError(() => {
        defaultRequestFn().then(resolve, reject);
        quickFetch.removeEarlyRequest(key);
      });
    });
  } else {
    return defaultRequestFn();
  }
};